/* eslint-disable jsx-a11y/control-has-associated-label */
import DP from "react-datepicker";
import fr from "date-fns/locale/fr";
import en from "date-fns/locale/en-US";
import de from "date-fns/locale/de";
import es from "date-fns/locale/es";
import ptBR from "date-fns/locale/pt-BR";
import { format } from "date-fns";

import Icon from "components/Icon/Icon";

import "./DatePicker.css";

const defaultButttonStyle =
  "inline-flex p-1 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded hover:bg-secondary hover:text-white hover:border-secondary focus:outline-none focus:ring-offset-0";

export type DatePickerProps = {
  onChange?: (value: any) => void;
  value?: any;
  placeholder?: string;
  showTimeSelect?: boolean;
  showYearDropdown?: boolean;
  timeIntervals?: number;
  minDate?: Date;
  disabled?: boolean;
  locale?: "en" | "fr" | "de" | "es" | "pt-BR";
};

const getLocale = (locale: string) => {
  switch (locale) {
    case "en":
      return en;
    case "fr":
      return fr;
    case "de":
      return de;
    case "es":
      return es;
    case "pt-BR":
      return ptBR;
    default:
      return fr;
  }
};

function DatePicker({
  placeholder = "",
  value = null,
  onChange = () => {},
  showTimeSelect = true,
  showYearDropdown = false,
  timeIntervals = 15,
  minDate,
  disabled,
  locale = "fr",
}: DatePickerProps) {
  const formattedValue = !value ? null : new Date(value);
  const handleChange = (newDate: Date) => onChange(newDate);

  return (
    <DP
      // dateFormat="dd/MM/yyyy HH:mm"
      dateFormat="dd LLL yyyy"
      locale={getLocale(locale)}
      selected={formattedValue}
      onChange={handleChange}
      placeholderText={placeholder}
      timeIntervals={timeIntervals}
      isClearable={!disabled}
      showTimeSelect={showTimeSelect}
      portalId="date-portal"
      minDate={minDate}
      disabled={disabled}
      showYearDropdown={showYearDropdown}
      renderCustomHeader={({
        date,
        changeYear,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="flex items-center justify-between px-2 py-2">
          <span className="font-bold capitalize text-lg text-slate-700">
            {format(date, showYearDropdown ? "MMMM" : "MMMM yyyy", {
              locale: getLocale(locale),
            })}
          </span>
          {showYearDropdown && (
            <select
              value={date.getFullYear()}
              onChange={({ target: { value: year } }) =>
                changeYear(Number(year))
              }
              className="font-bold capitalize text-lg text-slate-700 mr-2 border-none outline-none"
            >
              {Array.from(
                { length: new Date().getFullYear() - 1900 + 2 },
                (_, i) => (
                  <option key={i} value={1900 + i}>
                    {1900 + i}
                  </option>
                )
              )}
            </select>
          )}

          <div className="space-x-2">
            <button
              onClick={decreaseMonth}
              disabled={prevMonthButtonDisabled}
              type="button"
              className={`
                        ${
                          prevMonthButtonDisabled &&
                          "cursor-not-allowed opacity-50"
                        }
                        ${defaultButttonStyle}
                    `}
            >
              <Icon name="ChevronLeftIcon" className="w-4 h-4" />
            </button>

            <button
              onClick={increaseMonth}
              disabled={nextMonthButtonDisabled}
              type="button"
              className={`
                        ${
                          nextMonthButtonDisabled &&
                          "cursor-not-allowed opacity-50"
                        }
                      ${defaultButttonStyle}`}
            >
              <Icon name="ChevronRightIcon" className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    />
  );
}

export default DatePicker;
